import biscuit from '../utils/cookie-handler';

export const THEME_COOKIE = 'portal-theme';
export const THEME_COOKIE_TTL = 60 * 60 * 24 * 365;

const getSystemTheme = () => (
    window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches
        ? 'dark'
        : 'light'
);

export const getThemePreference = () => {
    const savedTheme = biscuit.getIt(THEME_COOKIE);
    return ['auto', 'light', 'dark'].includes(savedTheme) ? savedTheme : 'auto';
};

export const applyTheme = (theme) => {
    const selectedTheme = theme === 'auto' ? getSystemTheme() : theme;
    document.documentElement.setAttribute('data-bs-theme', ['light', 'dark'].includes(selectedTheme) ? selectedTheme : getSystemTheme());
    return selectedTheme;
};

const initThemeSwitcher = () => {
    const switcher = document.querySelector('[data-theme-switcher]');
    if (!switcher) return;

    const updateSelection = (theme) => {
        switcher.querySelectorAll('[data-theme-option]').forEach((option) => {
            const isSelected = option.dataset.themeOption === theme;
            option.classList.toggle('is-selected', isSelected);
            option.setAttribute('aria-pressed', String(isSelected));
        });
    };

    const themePreference = getThemePreference();
    applyTheme(themePreference);
    updateSelection(themePreference);

    switcher.addEventListener('click', (event) => {
        const option = event.target.closest('[data-theme-option]');
        if (!option) return;

        const themePreference = option.dataset.themeOption;
        applyTheme(themePreference);
        const cookieDomain = '.' + window.location.hostname.split('.').slice(-2).join('.');
        biscuit.remIt(THEME_COOKIE, '/');
        biscuit.setIt(THEME_COOKIE, themePreference, THEME_COOKIE_TTL, '/', cookieDomain);
        updateSelection(themePreference);
    });
};

export default initThemeSwitcher;
